import React from 'react';
// import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Switch from 'components/interaction/Switch/index.jsx';
import useSchoolSettings from '../../hooks/useSchoolSettings.js';
import messages from './messages.js';

function ProfilePictures() {
  const { settings, changeDetail } = useSchoolSettings();
  const { studentAvatarEnabled } = settings;
  return (
    <div>
      <h3><FormattedMessage {...messages.header} /></h3>
      <div className="d-flex">
        <Switch
          value={studentAvatarEnabled}
          onChange={(val) => changeDetail('studentAvatarEnabled', val)}
        />
        <span className="ms-3">
          <FormattedMessage {...messages.intro} />
        </span>
      </div>
    </div>
  );
}

// ProfilePictures.propTypes = {
// };

export default ProfilePictures;
